import Pebble00 from '@/assets/images/Scenario/elements/Pebble00.png';
import Pebble01 from '@/assets/images/Scenario/elements/Pebble01.png';
import Pebble02 from '@/assets/images/Scenario/elements/Pebble02.png';
import Pebble03 from '@/assets/images/Scenario/elements/Pebble03.png';
import Pebble04 from '@/assets/images/Scenario/elements/Pebble04.png';
import Pebble05 from '@/assets/images/Scenario/elements/Pebble05.png';
import Pebble06 from '@/assets/images/Scenario/elements/Pebble06.png';
import Pebble07 from '@/assets/images/Scenario/elements/Pebble07.png';
import Pebble08 from '@/assets/images/Scenario/elements/Pebble08.png';
import Pebble09 from '@/assets/images/Scenario/elements/Pebble09.png';
import { CommentStone } from '@/services/commentStonesApi';
import { getMediaUrl } from './mediaUrl';

export const COMMENT_STONE_ASSETS = [
  Pebble00,
  Pebble01,
  Pebble02,
  Pebble03,
  Pebble04,
  Pebble05,
  Pebble06,
  Pebble07,
  Pebble08,
  Pebble09,
];

export interface CommentStoneOption {
  id: string;
  name: string;
  price: number;
  imageUrl: string;
}

const STONE_NAME_BY_ID: Record<string, string> = {
  '1': 'Rome',
  '2': 'Green',
  '3': 'Swamp',
  '4': 'Timecaps Original',
  '5': 'Sun',
  '6': 'Vatican',
  '7': 'Mold',
  '8': 'Pick Me',
  '9': 'Pink',
  '10': 'Stone',
};

const isDirectMediaReference = (value: string) =>
  value.startsWith('/') ||
  value.startsWith('http://') ||
  value.startsWith('https://') ||
  value.includes('.');

export const mapCommentStonesToOptions = (
  stones: CommentStone[]
): CommentStoneOption[] =>
  stones.map((stone, index) => ({
    id: String(stone.id),
    name: STONE_NAME_BY_ID[String(stone.id)] ?? stone.name,
    price: Number(stone.price) || 0,
    imageUrl: COMMENT_STONE_ASSETS[index % COMMENT_STONE_ASSETS.length],
  }));

export const resolveCommentStoneImage = (
  commentObject?: string | null,
  stoneOptions: CommentStoneOption[] = []
) => {
  const normalized = commentObject?.trim();
  if (!normalized || normalized === 'capsule') {
    return undefined;
  }

  if (isDirectMediaReference(normalized)) {
    return getMediaUrl(normalized);
  }

  const matchedStone = stoneOptions.find(stone => stone.id === normalized);
  if (matchedStone) {
    return matchedStone.imageUrl;
  }

  const numericId = Number(normalized);
  if (Number.isFinite(numericId) && COMMENT_STONE_ASSETS.length > 0) {
    return COMMENT_STONE_ASSETS[
      Math.abs(numericId - 1) % COMMENT_STONE_ASSETS.length
    ];
  }

  return undefined;
};
